module.exports = __webpack_public_path__ + "img/pwa_iOS_01.d6bdb101.png";